import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, a = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M8.25 20.362c.853-.186 1.641-.627 2.311-1.206a5.75 5.75 0 1 0 7.504-8.522l.544-.625a4.32 4.32 0 0 0-6.518-5.672l-7.813 8.977a4.32 4.32 0 0 0 .423 6.096c1.105.961 2.363 1.212 3.55.952Zm8.951-15.317a2.82 2.82 0 0 0-3.979.276L10.06 8.955c.502.836.964 1.458 1.467 1.962A5.725 5.725 0 0 1 15 9.75c.57 0 1.12.083 1.64.237l.837-.963a2.82 2.82 0 0 0-.276-3.979ZM9.03 10.14l1.431 1.83a5.725 5.725 0 0 0-1.21 3.53c0 .842.18 1.641.506 2.362-.557.53-1.194.897-1.825 1.035-.735.16-1.507.024-2.245-.619a2.82 2.82 0 0 1-.276-3.979l3.619-4.16Zm2.12 7.162a4.25 4.25 0 0 0 8.086-2.166.758.758 0 0 1-.09.03l-7.9 2.117a.756.756 0 0 1-.095.02Zm7.7-3.602A4.253 4.253 0 0 0 15 11.25a4.25 4.25 0 0 0-4.235 4.616.748.748 0 0 1 .092-.03l7.899-2.118a.755.755 0 0 1 .094-.018Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  a
];
function n(r, d) {
  return e(), t("svg", o, [...c]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
